import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>
            Expert Healthcare.
            <br />
            Personalized for Your Family.
          </h1>

          <p>
            Guided health screenings, evidence-based advice, and quality care at a
            price that makes sense. 
            <br/>We are the partner you can trust for your
            family’s well-being.
          </p>

          <div className="hero-actions">
            {/* <Link to="/book-consultation" className="cta-button"> */}
            <Link to="/" className="cta-button">
              Book a Consultation
            </Link>

            <Link to="/" className="cta-button">
            {/* <Link to="/health-plans" className="cta-button"> */}
              Explore Our Health Plans
            </Link>
          </div>

          {/* Trust Introduction */}
        <div className="hero-intro">
          <h2>More Than Just a Healthcare Provider</h2>
          <p>
            In a world full of confusing internet advice and unnecessary medical tests,
            <strong> Gopalan Aarogyam </strong>
            stands as your trusted guide. We don’t just order tests; we care for your
            entire family.
          </p>
          <p>
            By combining modern medical technology with time-tested wisdom, we deliver
            genuine, thoughtful healthcare designed around real people, real needs, and
            long-term well-being.
          </p>
        </div>

        </div>
      </section>

      {/* Why Choose Us */}
      {/* <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Gopalan Aarogyam?</h2>
            <p>Healthcare built on trust, quality, and continuity of care</p>
          </div>

          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">👨‍⚕️</div>
              <h3>Experienced Medical Team</h3>
              <p>Qualified doctors with years of clinical expertise.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🧪</div>
              <h3>Advanced Diagnostics</h3>
              <p>Reliable lab testing using modern equipment.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">❤️</div>
              <h3>Patient-First Care</h3>
              <p>Personalized treatment focused on long-term health.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🕒</div>
              <h3>Accessible & Reliable</h3>
              <p>Timely consultations and dependable support.</p>
            </div>
          </div>
        </div>
      </section> */}
      {/* Core Features */}
      <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Gopalan Aarogyam?</h2>
            <p><b>Thoughtful, evidence-based healthcare designed around real people</b></p>
          </div>

          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🩺</div>
              <h3 className="feature-title">Guided Health Screenings</h3>
              <p>
                We believe prevention is better than cure. Our structured screening
                programs help detect diseases early, allowing timely intervention
                before complications develop. We don’t just hand you a report, we
                explain it.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🧪</div>
              <h3>Customised Care, No Unnecessary Tests</h3>
              <p>
                Every individual is unique. We design healthcare around your specific
                needs. A test without expert review is a waste of resources. We ensure
                every investigation brings you closer to optimal health.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🛡️</div>
              <h3>Disease Risk Modification</h3>
              <p>
                We don’t just treat symptoms, we change outcomes. Our risk modification
                programs proactively manage health factors, helping you avoid
                long-term complications before they take root.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">📚</div>
              <h3>Evidence-Based Health Education</h3>
              <p>
                The internet is full of noise. We filter the information for you. Our
                expert-guided, scientific health education is tailored to your
                condition, empowering you with the right knowledge to stay healthy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How We Help You */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Your Single Point of Contact for Family Health</h2>
            <p><b>We simplify healthcare by guiding you at every step</b></p>
          </div>

          <div className="process-grid">
            <div className="process-step">
              <div className="process-number">1</div>
              <h3>The First Contact</h3>
              <p>
                We are here to hold your hand whenever a health need arises.
                Gopalan Aarogyam becomes your first call for any medical concern.
              </p>
            </div>

            <div className="process-step">
              <div className="process-number">2</div>
              <h3>Expert Guidance</h3>
              <p>
                Our panel of experienced doctors and specialists carefully review
                your reports to curate the most appropriate healthcare plan for you.
              </p>
            </div>

            <div className="process-step">
              <div className="process-number">3</div>
              <h3>The Path to Health</h3>
              <p>
                Whether we treat you directly or guide you to the best facilities,
                we navigate the medical system so you don’t have to.
              </p>
            </div>
          </div>
        </div>
      </section>


    </>
  );
};

export default Home;
